module.exports = __webpack_public_path__ + "static/img/FWlogo.f12e67b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FWlogo.gif
// module id = r2cH
// module chunks = 1